import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, Global } from "@mantine/core";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      primaryColor: "cyan",
      colors: {
        cyan: [
          "#FFF4EF",
          "#FFE4D9",
          "#FFC2A8",
          "#FFA073",
          "#FF7A42",
          "#F25016", // ⭐ MAIN COLOR
          "#D64514",
          "#B83A11",
          "#922E0D",
          "#6B2109",
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: "#ffffff",
        },
      }}
    />
    <App />
  </MantineProvider>,
);
